import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback } from 'react';
import { useDebounceValue } from 'usehooks-ts';
export const FilteredFieldContext = createContext({
    filteredFieldText: '',
    onFilterChange: () => { },
    isGroupExpanded: false,
});
export const FilteredFieldProvider = (props) => {
    const [searchTerm, setSearchTerm] = useDebounceValue('', 500, { trailing: true });
    const onFilterChange = useCallback((_event, value = '') => {
        setSearchTerm(value);
    }, [setSearchTerm]);
    return (_jsx(FilteredFieldContext.Provider, { value: {
            filteredFieldText: searchTerm,
            onFilterChange,
            isGroupExpanded: searchTerm.length > 0,
        }, children: props.children }));
};
//# sourceMappingURL=filtered-field.provider.js.map